import Vue from 'vue';
// import "./plugins/analytics";
import './plugins/gtag';
import './plugins/vuetify';
import './plugins/clipboard';
import i18n from './plugins/i18n';
import App from './App.vue';
import router from './router';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/functions';
import 'firebase/firestore';
import { config } from './firebaseConfig';
import LoadScript from 'vue-plugin-load-script';
import * as Util from './misc/util';
import VueMeta from 'vue-meta';

Vue.use(VueMeta);
Vue.use(LoadScript);

Vue.config.productionTip = false;

// Initialize Firebase
firebase.initializeApp(config);
// NOTE: for debug locally
if (Util.isTestEnv() && process.env.VUE_APP_CLOUD_DB !== 'true') {
  if (window.location.hostname === 'hosting-xr.jp.ngrok.io') {
    firebase.functions().useFunctionsEmulator(window.location.protocol + '//functions-xr.jp.ngrok.io');
    firebase.firestore().useEmulator('firestore-xr.jp.ngrok.io', 80);
  } else {
    const firebaseEmulators = require('../../../v2/backend/firebase.json')['emulators'];
    firebase
      .functions()
      .useFunctionsEmulator(
        window.location.protocol + '//' + window.location.hostname + ':' + firebaseEmulators.functions.port
      );
    firebase.firestore().useEmulator('localhost', firebaseEmulators.firestore.port);
  }
}

let app = undefined;
firebase.auth().onAuthStateChanged(() => {
  // Initialize Vue
  if (app === undefined) {
    new Vue({
      i18n,
      router,
      render: h => h(App)
    }).$mount('#app');
  }
});
